var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"flat":"","color":"green"},on:{"click":_vm.openDashboard}},[_vm._v("View")])}
var staticRenderFns = []

export { render, staticRenderFns }